import { InventoryWebComponent } from '../component/InventoryWebComponent';
import { InventoryView } from '../view/InventoryView';
import { templateInventory } from '../view/template';
import { BaseWidgetController } from '../../widget/BaseWidgetController';
import { GetInventoryInformationResponse } from '@nirvana/shared/dtos/types/widgets/common';

export class InventoryController extends BaseWidgetController<GetInventoryInformationResponse> {
  public component: InventoryWebComponent;
  public view: InventoryView;
  public viewConstructor: typeof InventoryView;

  constructor(component: InventoryWebComponent) {
    super(component);
    this.initialWidgetSetup({
      viewConstructor: InventoryView,
      viewTemplate: templateInventory,
      dataFetchMethod: this.component.dependencies.api.clients.Widgets.getInventoryInformation,
    });
  }
}
